import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { ReunioesService } from '../../services/reunioes.service';

@Component({
  selector: 'app-nav-tabs',
  templateUrl: './nav-tabs.component.html',
  styleUrls: ['./nav-tabs.component.scss']
})
export class NavTabsComponent extends BaseFormComponent<any> implements OnInit {
  currentRoute:string = '';
  id:number;
  title:string = '';
  data:object[] = [
    {'id':'pauta','label':'Pauta', 'showInCreate': true},
    {'id':'itens','label':'Itens'},
    {'id':'ordem','label':'Ordem'},
    {'id':'anexos','label':'Anexos'},
    {'id':'participantes','label':'Participantes'}
  ];

  constructor(
    private router: Router,
    public activatedRoute: ActivatedRoute,
    public myService: ReunioesService,
    private navigation: NavigationService,
  ) { 
    super(activatedRoute);
  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      this.id = +params.get('id');
      this.title = params.get('type');
    });
  }

  isActive(route: string): boolean {
    if(this.router.routerState.snapshot.url.includes(route)){
      this.currentRoute = route;
      return true;
    }
    return false;
  }

  navigate(route:string){
    var currentUrl = this.router.routerState.snapshot.url;
    var newUrl = currentUrl.replace(this.currentRoute, route);
    this.router.navigate([newUrl]);
  }
  
  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  voltar() {
    this.navigation.back([`reuniao/reunioes`]);
    
  }

  excluir(): void {
    this.loading();
    this.myService.delete(this.id).subscribe({
      next: (res) => {
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.voltar();
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message)
      }
    });
  }
}
